import { render, staticRenderFns } from "./press_create.vue?vue&type=template&id=edce8e58&"
import script from "./press_create.vue?vue&type=script&lang=js&"
export * from "./press_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports